import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { LocationListCityCell } from './location-list-city.cell';
import { LocationListCityHeader } from './location-list-city.header';

export const LocationListCityColumn: IdentifiedColumnDef<
  GatewayLocationModel,
  GatewayLocationModel['city']
> = {
  enableSorting: false,
  header: LocationListCityHeader,
  cell: LocationListCityCell,
};
